import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useToast } from "hooks/useToast";
import { perkFormSchema } from "formValidations/perkSchema";
import { FormikForm } from "components/FormikForm/FormikForm";
import { useAdminCreatePerkMutation } from "store/apis/perksCrm";
import { BackendError } from "types/utils/error";
import { buildCreatePerkFormData } from "util/perks/buildPerkFormData";
import { EMPTY_PERK_FORM_VALUES } from "util/perks/perkFormValues";
import { PerkForm } from "./PerkForm";
import { PerkFormValues } from "./perksCrm.types";

type CreatePerkModalProps = {
  onClose: () => void;
};

export const CreatePerkModal = ({ onClose }: CreatePerkModalProps) => {
  const { successToast, alertToast } = useToast();
  const [adminCreatePerk, { isLoading }] = useAdminCreatePerkMutation();

  const handleSubmit = async (values: PerkFormValues) => {
    try {
      await adminCreatePerk(buildCreatePerkFormData(values)).unwrap();
      successToast({ message: "Perk created successfully" });
      onClose();
    } catch (err) {
      alertToast({
        message:
          (err as BackendError)?.data?.error?.message ||
          "Failed to create perk",
      });
    }
  };

  return (
    <Modal.Root open onOpenChange={onClose}>
      <Modal.Content size="xl" useCustomOverlay>
        <Modal.Header>
          <Modal.Title>Create Perk</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <FormikForm
          initialValues={EMPTY_PERK_FORM_VALUES}
          validationSchema={perkFormSchema}
          onSubmit={handleSubmit}
        >
          <Modal.Body>
            <PerkForm />
          </Modal.Body>
          <Modal.FooterButtonGroup>
            <Modal.RawClose asChild>
              <Button type="button" customType="secondary">
                Cancel
              </Button>
            </Modal.RawClose>
            <Button type="submit" customType="primary" isLoading={isLoading}>
              Create Perk
            </Button>
          </Modal.FooterButtonGroup>
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
